export default __webpack_public_path__ + "static/media/newrelic-negative.b2584ddc.svg";